import * as React from 'react';
import styled from 'styled-components';
import { Product, ClickoutArea } from '@packages/common';

import { Spacer, themeGet, media } from '@packages/ui';

import { Clickout } from '../../context/ClickoutContext';
import { ImpressionTracker } from '../../context/ImpressionTrackerContext';
import { RecommendationChannel } from '../../containers';

import { ProductCarousel } from '../ProductCarousel';

import { RecoTile } from '../../../../components/RecoTile';

const Container = styled.div`
  width: 100%;
  position: relative;
  margin-top: ${themeGet.space(4)};
`;

const CarouselWrapper = styled.div`
  position: relative;
  padding-left: ${themeGet.space(5)};
  padding-right: ${themeGet.space(5)};
  ${media.to.md`
    padding-left: 0px;
    padding-right: 0px;
  `}
`;

export interface QuickListProps {
  headerText: string;
  products?: Product[];
  wishlistHelper: any;
  categoryId?: string;
  recommendationChannel: RecommendationChannel;
  onRecoTileClick: (productId: string) => void;
}

export const QuickList: React.FC<QuickListProps> = ({
  headerText,
  products = [],
  wishlistHelper,
  categoryId,
  recommendationChannel,
  onRecoTileClick,
}) => {
  return products.length ? (
    <Container>
      <CarouselWrapper>
        <ProductCarousel
          slidesToShow={[3, 3, 4, 5, 6]}
          centered={[true, true, false]}
          recommendationChannel={recommendationChannel}
          categoryId={categoryId}
          title={headerText}
          slides={products.map((product, index) => (
            <Spacer p={[2]} key={`quickreco-${index}-${product.objectID}`}>
              <ImpressionTracker product={product} index={index}>
                <div onClick={() => onRecoTileClick(product.productId)}>
                  <RecoTile
                    index={index}
                    wishlistHelper={wishlistHelper}
                    product={product}
                    Clickout={Clickout}
                    area={index === 0 ? ClickoutArea.QUICKLIST_ORIGIN : ClickoutArea.QUICKLIST_RECOMMENDED}
                    highlight={index === 0}
                  />
                </div>
              </ImpressionTracker>
            </Spacer>
          ))}
        />
      </CarouselWrapper>
    </Container>
  ) : (
    <></>
  );
};
